(function () {
  var root = document.querySelector('[data-ai-assistant]');
  if (!root) return;

  var WA = root.dataset.whatsapp;
  var API = root.dataset.apiUrl;
  var TIMEOUT = parseInt(root.dataset.timeout || '180', 10) * 1000;
  var CURRENCY = root.dataset.shopCurrency || 'TRY';

  var bubble = root.querySelector('[data-aisa-toggle]');
  var panel = root.querySelector('[data-aisa-panel]');
  var closeBtn = root.querySelector('[data-aisa-close]');
  var msgsEl = root.querySelector('[data-aisa-messages]');
  var quickEl = root.querySelector('[data-aisa-quick]');
  var form = root.querySelector('[data-aisa-form]');
  var input = root.querySelector('[data-aisa-input]');
  var fallback = root.querySelector('[data-aisa-fallback]');

  var state = {
    step: 0,
    profile: { name: null, room: null, size: null, budget: null, style: null, feature: null },
    sessionStart: null,
    timer: null,
    purchased: false
  };

  // Conversation flow steps
  var FLOW = [
    {
      key: 'greet',
      bot: function () { return 'Merhaba! 👋 Ben Şölen Halı asistanınızım. Size en uygun halıyı bulmanıza yardım edeceğim. Önce adınızı öğrenebilir miyim?'; },
      input: 'text',
      save: 'name'
    },
    {
      key: 'room',
      bot: function (s) { return 'Memnun oldum ' + s.profile.name + '! 🌿 Halıyı hangi oda için arıyorsunuz?'; },
      quick: ['Salon', 'Yatak Odası', 'Mutfak', 'Çocuk Odası', 'Koridor'],
      save: 'room'
    },
    {
      key: 'size',
      bot: function () { return 'Harika seçim! Odanızın yaklaşık boyutu nedir?'; },
      quick: ['Küçük (80x150)', 'Orta (160x230)', 'Geniş (200x290)', 'Çok Geniş (300x400+)'],
      save: 'size'
    },
    {
      key: 'budget',
      bot: function () { return 'Bütçeniz hangi aralıkta?'; },
      quick: ['0-1.500 ₺', '1.500-3.500 ₺', '3.500-7.000 ₺', '7.000 ₺+'],
      save: 'budget'
    },
    {
      key: 'style',
      bot: function () { return 'Tarz olarak neyi tercih edersiniz?'; },
      quick: ['Modern', 'Klasik', 'Vintage', 'Boho', 'Düz / Sade'],
      save: 'style'
    },
    {
      key: 'feature',
      bot: function () { return 'Son bir şey: özel bir ihtiyaç var mı?'; },
      quick: ['Yıkanabilir', 'Pati Dostu', 'Hipoalerjenik', 'Önemli değil'],
      save: 'feature'
    },
    {
      key: 'recommend',
      bot: function (s) { return 'Mükemmel ' + s.profile.name + '! 🎯 Sizin için en uygun halıları seçtim:'; },
      action: 'recommend'
    }
  ];

  // Map room labels to Shopify collection handles
  var ROOM_TO_COLLECTION = {
    'Salon': 'salon-halisi',
    'Yatak Odası': 'yatak-odasi-halisi',
    'Mutfak': 'mutfak-halisi',
    'Çocuk Odası': 'cocuk-odasi-halisi',
    'Koridor': 'koridor-halisi'
  };

  function open() {
    panel.hidden = false;
    bubble.style.display = 'none';
    if (state.step === 0) start();
  }
  function close() {
    panel.hidden = true;
    bubble.style.display = 'flex';
  }

  bubble.addEventListener('click', open);
  closeBtn.addEventListener('click', close);

  function addMsg(text, who) {
    var d = document.createElement('div');
    d.className = 'aisa-msg aisa-msg--' + who;
    d.textContent = text;
    msgsEl.appendChild(d);
    msgsEl.scrollTop = msgsEl.scrollHeight;
    return d;
  }

  function typing() {
    var d = document.createElement('div');
    d.className = 'aisa-msg aisa-msg--bot aisa-msg--typing';
    d.innerHTML = '<span></span><span></span><span></span>';
    msgsEl.appendChild(d);
    msgsEl.scrollTop = msgsEl.scrollHeight;
    return d;
  }

  function setQuick(opts, onPick) {
    quickEl.innerHTML = '';
    if (!opts || !opts.length) return;
    opts.forEach(function (opt) {
      var b = document.createElement('button');
      b.type = 'button';
      b.textContent = opt;
      b.addEventListener('click', function () {
        addMsg(opt, 'user');
        quickEl.innerHTML = '';
        onPick(opt);
      });
      quickEl.appendChild(b);
    });
  }

  function botSay(text, then) {
    var t = typing();
    setTimeout(function () {
      t.remove();
      addMsg(text, 'bot');
      if (then) then();
    }, 600 + Math.random() * 400);
  }

  function start() {
    state.sessionStart = Date.now();
    state.timer = setTimeout(showFallback, TIMEOUT);
    runStep();
  }

  function runStep() {
    var step = FLOW[state.step];
    if (!step) return;

    if (step.action === 'recommend') {
      botSay(step.bot(state), function () { recommend(); });
      return;
    }

    botSay(step.bot(state), function () {
      if (step.quick) {
        setQuick(step.quick, function (val) {
          state.profile[step.save] = val;
          state.step++;
          runStep();
        });
      }
    });
  }

  // Free text input
  form.addEventListener('submit', function (e) {
    e.preventDefault();
    var v = input.value.trim();
    if (!v) return;
    addMsg(v, 'user');
    input.value = '';

    var step = FLOW[state.step];
    if (step && step.input === 'text') {
      state.profile[step.save] = v;
      state.step++;
      runStep();
      return;
    }

    // Free text → AI API or local fallback
    if (API) {
      callAI(v);
    } else {
      botSay('Anladım! Size doğru ürünü bulmama yardım etmesi için yukarıdaki seçeneklere devam edebilir misiniz? 🌱');
    }
  });

  function callAI(userMsg) {
    var t = typing();
    fetch(API, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ message: userMsg, profile: state.profile })
    })
      .then(function (r) { return r.json(); })
      .then(function (data) {
        t.remove();
        addMsg(data.reply || 'Size yardımcı olmaktan mutluluk duyarım!', 'bot');
      })
      .catch(function () {
        t.remove();
        addMsg('Şu an yanıt veremiyorum, bir uzmanımıza yönlendiriyorum 🌿', 'bot');
        showFallback();
      });
  }

  // Recommend products from Shopify collection
  function recommend() {
    var handle = ROOM_TO_COLLECTION[state.profile.room] || 'all';
    fetch('/collections/' + handle + '/products.json?limit=20')
      .then(function (r) { return r.json(); })
      .then(function (data) {
        var products = (data.products || []).filter(function (p) {
          return p.variants && p.variants[0] && parseFloat(p.variants[0].price) > 0;
        });
        var budget = parseBudget(state.profile.budget);
        if (budget) {
          products = products.filter(function (p) {
            var price = parseFloat(p.variants[0].price);
            return price >= budget[0] && price <= budget[1];
          });
        }
        if (!products.length) {
          // fallback: any from collection
          products = (data.products || []).slice(0, 3);
        }
        // shuffle and take 3
        products = products.sort(function () { return Math.random() - 0.5; }).slice(0, 3);
        renderProducts(products);

        botSay('Beğendiğiniz bir ürün var mı? Sepete eklemek için tıklayın. Ya da daha farklı seçenekler görmek isterseniz uzmanımıza bağlanabilirim 💚');
      })
      .catch(function () {
        addMsg('Ürünleri yüklerken bir sorun yaşadım. Bir uzmanımıza yönlendireyim mi?', 'bot');
        showFallback();
      });
  }

  function parseBudget(label) {
    if (!label) return null;
    if (label.indexOf('0-1.500') === 0) return [0, 1500];
    if (label.indexOf('1.500-3.500') === 0) return [1500, 3500];
    if (label.indexOf('3.500-7.000') === 0) return [3500, 7000];
    if (label.indexOf('7.000') === 0) return [7000, 999999];
    return null;
  }

  function formatPrice(p) {
    var n = parseFloat(p);
    return new Intl.NumberFormat('tr-TR', { style: 'currency', currency: CURRENCY, maximumFractionDigits: 0 }).format(n);
  }

  function renderProducts(products) {
    if (!products.length) {
      addMsg('Size uygun bir ürün bulamadım 😔', 'bot');
      showFallback();
      return;
    }
    var wrap = document.createElement('div');
    wrap.className = 'aisa-products';
    products.forEach(function (p) {
      var img = (p.images && p.images[0] && (p.images[0].src || p.images[0])) || '';
      var price = p.variants[0].price;
      var a = document.createElement('a');
      a.className = 'aisa-product';
      a.href = '/products/' + p.handle;
      a.target = '_blank';
      a.rel = 'noopener';
      a.innerHTML =
        '<img src="' + img + '" alt="">' +
        '<div class="aisa-product__info">' +
          '<div class="aisa-product__title">' + escapeHtml(p.title) + '</div>' +
          '<div class="aisa-product__price">' + formatPrice(price) + '</div>' +
          '<span class="aisa-product__btn">İncele →</span>' +
        '</div>';
      wrap.appendChild(a);
    });
    msgsEl.appendChild(wrap);
    msgsEl.scrollTop = msgsEl.scrollHeight;
  }

  function escapeHtml(s) {
    return String(s).replace(/[&<>"']/g, function (c) {
      return { '&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;',"'":'&#39;' }[c];
    });
  }

  function showFallback() {
    if (state.purchased) return;
    fallback.hidden = false;
    botSay('Size daha hızlı ve kişisel hizmet sunmak için bir uzmanımıza bağlanmak ister misiniz? 🌿');
    msgsEl.scrollTop = msgsEl.scrollHeight;
  }

  // Detect cart add (mark purchased)
  document.addEventListener('cart:added', function () { state.purchased = true; });
  document.addEventListener('cart:refresh', function () { state.purchased = true; });
  // Shopify Section Rendering API events vary by theme — also intercept fetch to /cart/add
  if (window.fetch) {
    var orig = window.fetch;
    window.fetch = function () {
      var args = arguments;
      var url = args[0];
      if (typeof url === 'string' && url.indexOf('/cart/add') !== -1) {
        state.purchased = true;
      }
      return orig.apply(this, args);
    };
  }
})();
